import React from 'react';

export function Title() {
  return (
    <div className="main-title-wrapper">
      <h1 className="title">
        Онлайн-запис на прийом до лікаря																																																														
      </h1>
      <div className="sub-title">Знайдіть лікаря або кабінет у закладах охорони здоров’я, які використовують МІС «Каштан», перегляньте доступний час та запишіться на прийом.</div>
    </div>
  );
}
